import { render } from "./MeasureResult.vue?vue&type=template&id=2067591a&scoped=true"
import script from "./MeasureResult.vue?vue&type=script&lang=js"
export * from "./MeasureResult.vue?vue&type=script&lang=js"

import "./MeasureResult.vue?vue&type=style&index=0&id=2067591a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2067591a"]])

export default __exports__